import * as signalR from "@aspnet/signalr";
import { List } from "immutable";
import { Abstract, AbstractType } from "../models/abstract";
import { Event } from "../models/event";
import { ItemLoadingState, ResourceUpdated } from "../models/generic";

export interface AbstractState {
    events: List<Event>;
    loadingAbstract: ItemLoadingState;
    loadingEvents: boolean;
    loadingEventType: ItemLoadingState;
    loadingType: ItemLoadingState;
    loadingUserAbstracts: boolean;
    mediaProcessing: ItemLoadingState;
    subscribedEventAbstracts: ResourceUpdated;
    subscribedUserAbstracts: ResourceUpdated;
    types: List<AbstractType>;
    userAbstracts: List<Abstract>;
    websocket?: signalR.HubConnection;
}

export const initialState: AbstractState = {
    events: List(),
    loadingAbstract: {},
    loadingEvents: true,
    loadingEventType: {},
    loadingType: {},
    loadingUserAbstracts: true,
    mediaProcessing: {},
    subscribedEventAbstracts: {},
    subscribedUserAbstracts: {},
    types: List(),
    userAbstracts: List(),
};



// WEBPACK FOOTER //
// ./src/store/AbstractState.ts